'use strict'
import _ from 'lodash'
import api from '../api'
import * as types from '../types'

// 表单验证函数放在这，保证全局可用
// 考虑到某些时候可能需要修改state，也许放在actions而不是一般函数是个好选择？
// 某些请求需要修改route和引用token，初定在params传入，sync获取不能
export default {
  actions: {
    [types.VERIFY_CELLPHONE] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (_.trim(value) === '') {
        cb(new Error('Enter a mobile phone number.'))
        return
      }

      if (_.isNaN(Number(value)) || !/^[0-9]*$/.test(value)) {
        cb(new Error('Mobile phone number format is wrong'))
        return
      }

      cb()
      // commit(types.EMPTY_MUTATION, params)
    },
		  [types.VERIFY_EMAIL] ({commit}, params) {
		      const value = params.value
		      const cb = params.callback
		      if (_.trim(value) === '') {
		        cb(new Error('Enter an email.'))
		        return
		      }
				
		      cb()
		      // commit(types.EMPTY_MUTATION, params)
		    },
		


    /*[types.VERIFY_CELLPHONE] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (_.trim(value) === '') {
        cb(new Error('cell phone number can not be empty'))
        return
      }

      if (_.isNaN(Number(value)) || !/^1[34578]\d{9}$/.test(value)) {
        cb(new Error('Mobile phone number format is wrong'))
        return
      }

      if (value.length !== 11) {
        cb(new Error('The phone number must be 11.'))
        return
      }
      cb()
      // commit(types.EMPTY_MUTATION, params)
    },*/
    [types.VERIFY_LOGIN_PASSWORD] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '' || value === undefined) {
        cb(new Error('VERIFY_LOGIN_PASSWORD This password field cannot be left blank.'))
        return
      }

      if (value.length < 8 || value.length > 16) {
        cb(new Error('The length of login passwords must be within 8 to 16 characters'))
        return
      }
      cb()
      // commit(types.EMPTY_MUTATION, params)
    },
    [types.VERIFY_LOGIN_VERIFICATION_CODE] ({commit, getters}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('Verification code cannot be empty'))
        return
      }

      if (_.isNaN(Number(value))) {
        cb(new Error('Verifying code format is wrong'))
        return
      }

      return api.validateImageVerificationCode({
        token: getters[types.GET_USER].token,
        validCode: value
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          cb()
        } else {
          cb(new Error('Verifying code is wrong'))
        }
        return res
      })
    },
    [types.VERIFY_MOBILE] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('This field cannot be left blank.'))
        return
      }
      if (!value.includes('@')) {
        cb(new Error('Invalid Email'))
        return
      }
/*      if (/^\d{8,16}$|^[a-zA-Z]{8,16}$|^\W{8,16}$/.test(value)) {
        cb(new Error('The password must be 22 combinations of English letters, numbers and characters.'))
        return
      }*/
      // 现在不需要做这个匹配了
      // if (/(.)\1{4,}/g.test(value)) {  // 有4个以上重复的字符就视为简单
      //   cb(new Error('登录密码过于简单'))
      //   return
      // }
      cb()
    },
    [types.VERIFY_REGISTER_PASSWORD] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('This field cannot be left blank.'))
        return
      }
      if (value.length < 8 || value.length > 16) {
        cb(new Error('password is 8-16 bits'))
        return
      }
/*      if (/^\d{8,16}$|^[a-zA-Z]{8,16}$|^\W{8,16}$/.test(value)) {
        cb(new Error('The password must be 22 combinations of English letters, numbers and characters.'))
        return
      }*/
      // 现在不需要做这个匹配了
      // if (/(.)\1{4,}/g.test(value)) {  // 有4个以上重复的字符就视为简单
      //   cb(new Error('登录密码过于简单'))
      //   return
      // }
      cb()
    },
    // [types.VALIDATE_SMS_VERIFICATION_CODE] ({commit}, params) {},
    [types.VERIFY_MUST_CHECKED] ({commit}, params) {
      const cb = params.callback
      if (params.value === false) {
        cb(new Error(params.rules.message))
      } else {
        cb()
      }
    },
    [types.VERIFY_PASSWORD_VALID] ({commit, getters}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error(params.rules.message ? params.rules.message : 'This VERIFY_PASSWORD_VALID password field cannot be left blank.'))
        return
      }

      return api.validateOldLoginPassword({
        token: getters[types.GET_USER].token,
        password: value
      }).then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          cb()
        } else {
          cb(new Error('Password filling error'))
        }
        return res
      })
    },
    [types.VERIFY_CHN_NAME] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (value === '') {
        cb(new Error('The name cannot be empty'))
        return
      }
      if (!(/^[\u4E00-\u9FFF]+$/.test(value))) {
        cb(new Error('Name must be Chinese characters'))
        return
      }
      if (value.length > 30) {
        cb(new Error('The length of the name should not exceed 30'))
        return
      }
      cb()
    },
    [types.VERIFY_ID_CARD_NUM] ({commit}, params) {
      const value = params.value
      const cb = params.callback
      if (_.trim(value) === '') {
        cb(new Error('ID number can not be empty'))
        return
      }
      if (_.trim(value).length < 18) {
        cb(new Error('Must be 18 ID ID number'))
        return
      }
      if (!(/^[1-9]{1}\d{14}$|^[1-9]{1}\d{16}(\d|[xX])$/.test(value))) {
        cb(new Error('ID card number format error'))
        return
      }
      cb()
    },
    [types.VERIFY_BANKCARD_NUM] ({commit}, params) {
      const value = params.value.replace(/\s/g, '')
      const cb = params.callback
      if (value.trim() === '') {
        cb(new Error('Please enter an account opening account'))
      } else if (_.isNaN(Number(value))) {
        cb(new Error('Please enter the correct bank card account number'))
      } else if (value.length < 12) {
        cb(new Error('The bank card account number can not be less than 12 bits'))
      } else if (value.length > 30) {
        cb(new Error('The bank card account number can not be less than 30 bits'))
      } else {
        cb()
      }
    },
    [types.VERIFY_MUST_SELECTED] ({commit}, params) {
      const cb = params.callback
      if (params.value === '') {
        cb(new Error(params.rules.message))
      } else {
        cb()
      }
    },
    [types.VERIFY_ENTERPRISE_ORGANIZING_NUMBER] ({commit}, params) {
      const cb = params.callback
      if (_.trim(params.value) === '') {
        cb(new Error('The code number of the organization code can not be empty'))
      } else if (!/\d{8}-\w{1}/g.test(params.value)) {
        cb(new Error('The organization code card number is composed of 18 digits'))
      } else {
        cb()
      }
    },
    [types.VERIFY_SOCIAL_CREDIT_CODE] ({commit}, params) {
      const cb = params.callback
      if (_.trim(params.value) === '') {
        cb(new Error('Social credit code number cannot be empty'))
      } else if (!/\w{20}/g.test(params.value)) {
        cb(new Error('The social credit code number is composed of 20 digit numbers and English letters.'))
      } else {
        cb()
      }
    },
    [types.VERIFY_ENTERPRISE_NUMBER] ({commit}, params) {
      const cb = params.callback
      if (_.trim(params.value) === '') {
        cb(new Error('The business license number is not empty'))
      } else {
        cb()
      }
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/vuex/modules/form.js